import { createAccessControl } from "better-auth/plugins/access";
import { defaultStatements, adminAc } from "better-auth/plugins/admin/access";

export const statement = {
  ...defaultStatements,
  file: ["create", "update", "delete", "export", "give-access", "view-all"],
  translationUnit: ["update", "delete"],
  terminology: ["upload", "view"],
  jobs: ["read"],
} as const;

export const ac = createAccessControl(statement);

export const basic = ac.newRole({
  file: ["update"],
  terminology: ["view"],
});

export const advanced = ac.newRole({
  ...basic.statements,
  file: ["create", "delete", "export", ...basic.statements.file],
  terminology: ["upload", ...basic.statements.terminology],
  jobs: ["read"],
});

export const admin = ac.newRole({
  ...advanced.statements,
  file: [...advanced.statements.file, "give-access", "view-all"],
  ...adminAc.statements,
});

export const roles = {
  basic,
  advanced,
  admin,
};
